import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const LeafIcon = ({ color = Color.Green400, className }: NewIconProps) => (
  <svg
    className={twMerge('size-[24px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_13550_3992)">
      <path
        d="M0.018597 7.9814C2.37791 8.11945 4.49877 7.49196 5.99844 5.99854C7.49811 4.50513 8.11931 2.37795 7.98126 0.0185974C5.62196 -0.11945 3.49481 0.508037 2.00142 2.00146C0.508028 3.49487 -0.119448 5.62205 0.018597 7.9814Z"
        fill={color}
      />
    </g>
    <defs>
      <filter
        id="filter0_i_13550_3992"
        x="0"
        y="0"
        width="100%"
        height="100%"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_13550_3992" />
      </filter>
    </defs>
  </svg>
);
